import ProductInfo from "./ProductInfo";
customElements.define('product-info', ProductInfo)
